import { normalizeEmails } from '@/utilities/validateEmail';

// email_order_subscriptions are stored one row per (event x email) combination, while
// this tab's state is an object keyed by event name plus a primary/secondary email split.
// These two helpers are the round trip between those shapes.

export const hydrateSubscriptionState = (existing) => {
    const rows = existing || [];

    return {
        // Keyed by event name to match the toggles and the Select All handler. Unknown
        // event names are kept so an event this build does not render is not silently
        // dropped from the order's subscriptions on the next save.
        selectedEvents: Object.fromEntries(rows.filter(({ event }) => event).map(({ event }) => [event, true])),
        // De-duped: with N events the same email appears N times.
        emails: [...new Set(rows.map(({ email }) => email).filter(Boolean))],
    };
};

// order_id is stamped on at the save boundary (EditOrderModal's onSave), so it is
// deliberately absent here — one owner for that field.
export const buildSubscriptionRows = ({ selectedEvents, primaryEmail, secondaryEmails }) => {
    // normalizeEmails owns trimming, case-insensitive de-duping and validation. Going through it
    // rather than splitting locally matters on three counts, all of which land in the database
    // because insert_email_order_subscriptions has no on_conflict and the table has no unique
    // constraint on (order_id, event, email):
    //   - the same address typed as both primary and secondary inserts duplicate rows, so the
    //     recipient gets every notification twice, forever;
    //   - `A@rlx.us` and `a@rlx.us` are the same mailbox but not the same string;
    //   - these rows become SendGrid recipients, so an unvalidated value carries the header
    //     injection that utilities/validateEmail.js was written to block.
    // A whitespace-only primary is dropped here too — `.filter(Boolean)` alone let ' ' through as
    // an unsendable row, which is the very thing the old comment claimed to prevent.
    const { emails } = normalizeEmails([primaryEmail, ...(secondaryEmails || '').split(',')]);

    const events = Object.keys(selectedEvents || {}).filter((event) => selectedEvents[event]);

    return emails.flatMap((email) => events.map((event) => ({ event, email })));
};
